module.exports = __webpack_public_path__ + "img/top-sub-3.0ea143b.png";